import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

import Header from '../components/Header';
import TabMenu from '../components/TabMenu';

import Container from '@mui/material/Container';

function Main() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loginUser, setLoginUser] = useState(state?.loginUser);

  const fetchLoginUser = async () => {
    try {
      const result = await axios.get('/v1/auth/tokenVerification');
      setLoginUser(result.data.loginUser);
    } catch (err) {
      navigate('/login', { replace: true });
    }
  };

  // メイン画面のURLに直接アクセスした場合、トークンが無効ならログイン画面にリダイレクト
  useEffect(() => {
    if (!loginUser) {
      fetchLoginUser();
    }
  }, []);

  if (!loginUser) {
    return <>Loading...</>;
  }

  return (
    <>
      <Container disableGutters maxWidth={false}>
        <Header loginUser={loginUser} />
        <TabMenu loginUser={loginUser} />
      </Container>
    </>
  );
}

export default Main;
